import React from 'react';
import PropTypes from 'prop-types';
import ResponsiveDataList from './ResponsiveDataList';
import pageSizeUtil from '../../util/pageSize';
import PaginationHeader from '../PaginationHeader';
import Pagination, { getPagingInfo } from '../Pagination';

export default class PagingDataList extends React.Component {
  static propTypes = {
    activePage: PropTypes.number,
    data: PropTypes.array.isRequired,
    isLoadingData: PropTypes.bool,
    maxButtons: PropTypes.number,
    pageSize: PropTypes.number,
    onPageChange: PropTypes.func.isRequired,
    totalCount: PropTypes.number
  };

  static defaultProps = {
    resultsDisplayed: true
  };

  constructor(props){
    super(props);
    this.state = {
      activePage: props.activePage || 1
    };
  }

  componentDidMount() {
    if(this.props.pageSize && this.props.pageSize !== pageSizeUtil()) {
      this.changePageSize(this.props.pageSize);
    }
  }

  componentWillReceiveProps(newProps) {
    const { activePage } = newProps;

    if(!!activePage && activePage !== this.state.activePage) {
      this.setState({ activePage });
    }
  }

  onPageChange = (eventKey) => {
    this.setState({
      activePage: eventKey
    });
    this.props.onPageChange(eventKey);
  }

  highlightRow = value => {
    if (this.responsiveDataList) {
      this.responsiveDataList.highlightRow(value);
    }
  };

  changePageSize = (page_size) => {
    pageSizeUtil(page_size);
    this.props.onPageChange(1);
  }

  render() {
    const pagingInfo = getPagingInfo(this.props);

    return (
      <>
        <PaginationHeader
          {...this.props}
          activePage={this.state.activePage}
          hasPagination={pagingInfo.hasPagination}
          showPageSizeDropdown={!this.props.pageSize}
          pSize={pagingInfo.pageSize}
          changePageSize={this.changePageSize}
          dataSize={pagingInfo.dataSize}
        />
        <ResponsiveDataList
          {...this.props}
          ref={responsiveDataList => { this.responsiveDataList = responsiveDataList; }}
        />
        {pagingInfo.hasPagination &&
          <Pagination
            data={this.props.data}
            activePage={this.state.activePage}
            isLoadingData={this.props.isLoadingData}
            maxButtons={this.props.maxButtons}
            pageSize={this.props.pageSize}
            totalCount={this.props.totalCount}
            onPageChange={this.onPageChange}
          />}
      </>
    );
  }
}
